import React from "react";
import { Link, useLocation } from "react-router-dom";
import CustomButton from "../pages/custombutton";
import {
  FaFacebookF,
  FaInstagram,
  FaYoutube,
  FaTiktok,
  FaXTwitter,
} from 'react-icons/fa6';

const Footer = () => {
  const { pathname } = useLocation();
  return (
    <div className="mt-14">
      {/* <section class="bg-[#A5CD39] text-white max-w-screen-xl mx-auto my-5"> */}
      {pathname === '/' && (
        <section class="bg-slate-400 text-black  mx-auto" style={{ display: "none" }}>
          <div class=" px-4 py-8 mx-auto lg:py-16 lg:px-6">
            <div class="max-w-screen-sm mx-auto text-center">
              <h2 class="mb-4 text-2xl md:text-3xl lg:text-4xl font-bold leading-tight tracking-tight capitalize">
                Start Your Journey Today
              </h2>
              <p class="mb-6 font-normal md:text-xl">
                {/* Try Fixlall Platform for 30 days. No credit card required. */}
                Try Fixall with Complete Solution.
              </p>
              <CustomButton to="/request-demo" label="Request a Demo" color="#E53935" />

            </div>
          </div>
        </section>
      )}

      <footer class="bg-[#222E3D]" style={{ display: "none" }}>
        <div class=" max-w-screen-xl xl:max-w-screen-2xl p-4 py-6 mx-auto lg:py-16 md:p-8 lg:p-10">
          <div class="grid text-white grid-cols-2 gap-8 md:grid-cols-3 lg:grid-cols-4 mx-auto">
            <div className="">
              <h3 class="mb-6 text-sm font-medium md:font-semibold uppercase ">
                Company
              </h3>
              <ul class=" text-sm md:text-base">
                <li class="mb-4">
                  <a class="hover:underline" href="/about">
                    About
                  </a>
                </li>
                <li class="mb-4">
                  <a class="hover:underline" href="/careers">
                    Careers
                  </a>
                </li>
                <li class="mb-4">
                  <a class="hover:underline" href="/brandCenter">
                    Brand Center
                  </a>
                </li>
                <li class="mb-4">
                  <a class="hover:underline" href="/blog">
                    Blog
                  </a>
                </li>
              </ul>
            </div>
            <div>
              <h3 class="mb-6 text-sm font-medium md:font-semibold uppercase ">
                Help center
              </h3>
              <ul class=" text-sm md:text-base">
                <li class="mb-4">
                  <a class="hover:underline" href="#">
                    Discord Server
                  </a>
                </li>
                <li class="mb-4">
                  <a class="hover:underline" href="#">
                    Twitter
                  </a>
                </li>
                <li class="mb-4">
                  <a class="hover:underline" href="#">
                    Facebook
                  </a>
                </li>
                <li class="mb-4">
                  <a class="hover:underline" href="/contact">
                    Contact Us
                  </a>
                </li>
              </ul>
            </div>
            <div>
              <h3 class="mb-6 text-sm font-medium md:font-semibold uppercase ">
                Legal
              </h3>
              <ul class=" text-sm md:text-base">
                <li class="mb-4">
                  <a class="hover:underline" href="/privacyPolicy">
                    Privacy Policy
                  </a>
                </li>
                <li class="mb-4">
                  <a class="hover:underline" href="/licensing">
                    Licensing
                  </a>
                </li>
                <li class="mb-4">
                  <a class="hover:underline" href="/terms">
                    Terms
                  </a>
                </li>
              </ul>
            </div>
            <div>
              <h3 class="mb-6 text-sm font-medium md:font-semibold uppercase ">
                Developer
              </h3>
              <ul class=" text-sm md:text-base">
                <li class="mb-4">
                  <a class="hover:underline" href="https://developer.fixall.ai">
                    Developer Center
                  </a>
                </li>
              </ul>
            </div>
          </div>
          {/*
          <hr class="my-6 border-gray-200 sm:mx-auto lg:my-8" />
          <div class="text-center">
            <ul class="flex justify-center mt-5 space-x-10">
              <li>
                <Link href="#">
                  <img src="/facebook.png" className="h-6 " />
                </Link>
              </li>
              <li>
                <Link href="#">
                  <img src="/linkedin.png" className="h-6 " />
                </Link>
              </li>
              <li>
                <Link href="#">
                  <img src="/instagram.png" className="h-6 " />
                </Link>
              </li>
              <li>
                <Link href="#">
                  <img src="/youtube.png" className="h-6 " />
                </Link>
              </li>
            </ul>
          </div>
          */}
          {/* <div class="text-center ">
            <ul class="flex justify-center mt-5 space-x-5">
              <li>
                <Link href="#">
                  <p>Home</p>
                </Link>
              </li>
              <li>
                <Link href="#">
                  <p>Contact Us</p>
                </Link>
              </li>
              <li>
                <Link href="#">
                  <p>Security</p>
                </Link>
              </li>
              <li>
                <Link href="#">
                  <p>Compliance</p>
                </Link>
              </li>
              <li>
                <Link href="#">
                  <p>IPR Complaints</p>
                </Link>
              </li>
              <li>
                <Link href="#">
                  <p> Anti-spam Policy </p>
                </Link>
              </li>
              
              
            </ul>
          </div> */}

          <div className="max-w-screen-xl mx-auto p-4 mt-4">
            <div className="flex flex-wrap justify-center gap-4 text-sm md:text-base text-white">
              <a href="#" className="hover:text-white">
                Home
              </a>
              <span className="">|</span>
              <a href="/contact" className="">
                Contact Us
              </a>
              <span className="">|</span>
              <a href="#" className="">
                Security
              </a>
              <span className="">|</span>
              <a href="#" className="">
                Compliance
              </a>
              <span className="">|</span>
              <a href="#" className="">
                IPR Complaints
              </a>
              <span className="">|</span>
              <a href="#" className="">
                Anti-spam Policy
              </a>
              <span className="">|</span>
              <a href="#" className="">
                Terms of Service
              </a>
              <span className="">|</span>
              <a href="/privacy-policy" className="">
                Privacy Policy
              </a>
              <span className="">|</span>
              <a href="#" className="">
                Cookie Policy
              </a>
              <span className="">|</span>
              <a href="#" className="">
                GDPR Compliance
              </a>
              <span className="">|</span>
              <a href="#" className="">
                Abuse Policy
              </a>
            </div>
          </div>
        </div>

        {/* Bottom Footer */}
        <div className="text-center p-10 bg-[#101215]">
          <Link
            class="flex items-center justify-center mb-5 text-2xl font-semibold text-gray-900 "
            to="/"
          >
            <img src="/fixallogo.png" alt="" className="h-12" />
          </Link>

          <span class="block text-sm text-center text-white">
            © 2021-2022 Fixall™. All Rights Reserved. Built with
          </span>
        </div>
      </footer>

      <footer className="bg-white border-t border-gray-200 text-center">
        <div className="max-w-12xl mx-auto px-4 p-5" style={{ background: "#000" }}>
          <div className="mb-4 text-center">
            <div className="flex justify-content-center">
              <img src="/fixallogo.png" alt="" className="h-12 m-auto" />
            </div>
          </div>

          <div className="flex footerWidth justify-center flex-wrap space-x-4 border-y border-gray-200 py-3 text-sm text-gray-700 m-auto">
            {['Products', //'Pricing', 'Resources', 'Use Cases', 'API Docs', 'Support', 
            'Contact Us'].map((item, idx) => (
              <React.Fragment key={item}>
                {idx > 0 && <span className="text-white">|</span>}
                {(item === 'Contact' || item === 'Products') ? (
                  <Link
                    to={item === 'Contact' ? '/contact' : '/products'}
                    className="hover:underline text-white"
                  >
                    {item}
                  </Link>
                ) : (
                  <span className="hover:underline text-white cursor-pointer">{item}</span>
                )}
              </React.Fragment>
            ))}
          </div>

          {/*
          <div className="flex justify-center mt-4 space-x-4">
            {[FaFacebookF, FaInstagram, FaYoutube, FaTiktok, FaXTwitter].map((Icon, i) => (
              <a
                key={i}
                href="#"
                className="bg-gray-100 rounded-full p-2 hover:bg-gray-200 transition"
              >
                <Icon className="h-5 w-5 text-gray-700" />
              </a>
            ))}
          </div>
          */}
         </div>  {/* <!-- end of max-w-12xl wrapper --> */}
        

        <div className="bg-dark-100 text-xs text-gray-500 py-4 flex justify-between lg:px-24 px-0 items-center bottomText">
          <p className="font-bold">© 2025 Fix Labs Pvt. Ltd.</p>
          <div className="mt-1">
            <a href="/privacy-policy" className="font-bold hover:underline">Privacy Policy</a> |{' '}
            <a href="#" className="hover:underline font-bold">Terms of Service</a> {/*|{' '}
            <a href="#" className="hover:underline font-bold">LinkedIn</a> |{' '}
            <a href="#" className="hover:underline font-bold">Twitter</a> |{' '}
            <a href="#" className="hover:underline font-bold">YouTube</a>*/}
          </div>
        </div>
      </footer>

    </div>
  );
};

export default Footer;
